<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import CustomerFieldErrorMessageMixin from './mixins/customer_field_error_message';

import Icon from '~/components/icon.vue';

export default {
  components: {
    Icon
  },

  mixins: [CustomerFieldErrorMessageMixin],

  data() {
    return {
      isFocus: {
        day: false,
        month: false,
        year: false
      }
    };
  },

  computed: {
    ...mapState([
      'inputs'
    ]),

    ...inputAccessors([
      'day',
      'month',
      'year'
    ]),

    ...mapState({
      error(state) {
        return state.inputs['day'].error ||
          state.inputs['month'].error ||
          state.inputs['year'].error;
      }
    }),

    inputClass() {
      return {
        'row mb-4': true,
        'c-form__field--error': this.error
      };
    }
  },

  methods: {
    ...mapActions([
      'validateField'
    ]),

    ...mapMutations({
      setValue: 'setInputValue'
    }),

    inputValid(name) {
      const { value, error } = this.inputs[name];
      if (value) return !error && value.length > 0 && !this.isFocus[name];
      return false;
    },

    inputFocused(name) {
      this.isFocus[name] = true;
    },

    inputFocusedOut(name) {
      this.isFocus[name] = false;

      this.validateField(name);
    }
  },
};

/**
 * Helper function to create Vue computed entries for input fields using the store.
 */
function inputAccessors(keys) {
  const accessors = {};

  keys.forEach((key) => {
    accessors[key] = {
      get() {
        return this.inputs[key].value;
      },

      set(value) {
        this.setValue({
          name: key,
          value
        });
      }
    };
  });

  return accessors;
}
</script>

<template>
  <div :class="inputClass">
    <div class="c-form__input col-md-4 mb-4 mb-md-0">
      <label for="transaction_details_dateofbirth">
        {{ t('pay.js.marketing.payment_information.inputs.dateofbirth') }}
      </label>

      <input
        id="payment_page_day"
        v-model="day"
        name="transaction_details[dobday]"
        class="day"
        type="tel"
        maxlength="2"
        placeholder="DD"
        @focus="inputFocused('day')"
        @focusout="inputFocusedOut('day')"
      >

      <div
        v-if="inputValid('day')"
        class="c-form__input__status"
      >
        <icon
          name="check"
          size="small"
        />
      </div>
    </div>

    <div class="c-form__input col-md-4 mb-4 mb-md-0">
      <input
        id="payment_page_month"
        v-model="month"
        name="transaction_details[dobmonth]"
        class="month"
        type="tel"
        maxlength="2"
        placeholder="MM"
        @focus="inputFocused('month')"
        @focusout="inputFocusedOut('month')"
      >
      <div
        v-if="inputValid('month')"
        class="c-form__input__status"
      >
        <icon
          name="check"
          size="small"
        />
      </div>
    </div>

    <div class="c-form__input col-md-4">
      <input
        id="payment_page_year"
        v-model="year"
        name="transaction_details[dobyear]"
        class="year"
        type="tel"
        maxlength="4"
        placeholder="YYYY"
        @focus="inputFocused('year')"
        @focusout="inputFocusedOut('year')"
      >
      <div
        v-if="inputValid('year')"
        class="c-form__input__status"
      >
        <icon
          name="check"
          size="small"
        />
      </div>
    </div>

    <div class="c-form__feedback col">
      {{ errorMessage }}
    </div>
  </div>
</template>
